import axios from 'axios'

export function getCampaigns (context) {
  const url = this.$config.panoramas.campaigns
  const config = {
    headers: context.rootGetters['auth/headers']
  }
  axios.get(url, config)
    .then(response => {
      if (response.data && response.data.length > 0) {
        context.commit('setCampaigns', response.data)
      }
    })
}

export function getPanoByPoint (context, latLng) {
  context.commit('errorFetching', false)
  context.commit('loading', true)

  if (!context.state.campaigns) {
    const url = this.$config.panoramas.campaigns
    const config = {
      headers: context.rootGetters['auth/headers']
    }
    axios.get(url, config)
      .then(response => {
        if (response.data && response.data.count > 0) {
          context.commit('setCampaigns', response.data)
        }
      })
      .then(() => {
        _getPanoByPoint(context, this.$config, latLng)
      })
  } else {
    _getPanoByPoint(context, this.$config, latLng)
  }
}

export function selectCampaign (context, poi) {
  const selectedCampaign = context.state.campaigns.filter(campaign => campaign.id === poi.properties.campaign)[0]
  const folderLaterals = formatFolder(selectedCampaign.folder_img, this.$config.panoramas.media)
  context.commit('setFolderLateralsCampaign', folderLaterals)
  const folderPointCloud = formatFolder(selectedCampaign.folder_pc, this.$config.panoramas.media)
  context.commit('setFolderPointCloudCampaign', folderPointCloud)
}

function formatFolder (folder, media) {
  if (!folder) {
    return media
  }

  if (!folder.endsWith('/')) {
    folder = folder + '/'
  }
  if (!folder.startsWith('https')) {
    folder = media + folder
  }
  return folder
}

function distanceXY (latlng1, latlng2) {
  return Math.sqrt((latlng1.lat - latlng2.lat) * (latlng1.lat - latlng2.lat) + (latlng1.lng - latlng2.lng) * (latlng1.lng - latlng2.lng))
}

function projectedRadius (latLng, radius) {
  return radius / 40000000.0 * 360.0 / Math.cos(latLng.lat / 360.0 * Math.PI)
}

function isFarEnough (latlng1, latlng2, radius) {
  return distanceXY(latlng1, latlng2) > projectedRadius(latlng2, radius)
}

function _getPanoByPoint (context, $config, latLng) {
  const url = $config.panoramas.search
  let config = {
    params: {
      p: `${latLng.lat},${latLng.lng}`,
      r: $config.panoramas.radius
    },
    headers: context.rootGetters['auth/headers']
  }
  if (context.state.selectedCategory) {
    config.params['c'] = context.state.selectedCategory.code
  }
  axios.get(url, config)
    .then(response => {
      if (response.data.poi.features.length > 0) {
        context.commit('setResult', response.data)
        const poi = response.data.poi.features[0]
        context.commit('setNeighbours', response.data.poi.features.splice(1))
        context.dispatch('setPoi', poi)
      } else if (context.state.latLng && isFarEnough(context.state.latLng, latLng, config.params.r)) {
        context.commit('setResult', null)
        context.commit('setNeighbours', null)
        context.dispatch('setPoi', null)
        context.commit('setLatLng', null)
      }

      const file = {
        POTREE: 'cloud.js',
        POTREE2: 'metadata.json'
      }
      const pcs = response.data.pc.features.map(pc => {
        pc.properties['folder'] = getPCFolder(context.state.campaigns, pc)
        if (pc.properties.folder.startsWith('http')) {
          pc.properties['url'] = [pc.properties.folder, pc.properties.filename, file[pc.properties.format]].join('/')
        } else {
          pc.properties['url'] = [$config.panoramas.potreeResources, pc.properties.folder, pc.properties.filename, file[pc.properties.format]].join('/')
        }
        return pc
      })
      context.commit('setCurrentPointclouds', pcs)
    })
    .catch(() => {
      context.commit('errorFetching', true)
    }).then(() => {
      context.dispatch('setSrcPannellum')
      context.dispatch('setSrcPotree')
      context.commit('loading', false)
    })
}

function getPCFolder (campaigns, pc) {
  const poiCampaign = campaigns.filter(campaign => campaign.id === pc.properties.campaign)[0]
  if (pc.properties.folder?.startsWith('http')) {
    return pc.properties.folder
  }
  let pcFolder = [poiCampaign.folder_pc, pc.properties.folder].join('/')
  return pcFolder
}

function getPoiFolder (campaigns, poi, media) {
  const poiCampaign = campaigns.filter(campaign => campaign.id === poi.properties.campaign)[0]
  if (poi.properties.folder?.startsWith('http')) {
    return poi.properties.folder
  }
  let poiFolder = [poiCampaign.folder_pano, poi.properties.folder].join('/')
  return formatFolder(poiFolder, media)
}

export function setPoi (context, poi) {
  if (!poi) {
    context.commit('setAltitude', null)
    context.commit('setName', null)
    context.commit('setDate', null)
    context.commit('setPan', null)
    context.commit('setPitch', null)
    context.commit('setRoll', null)
    context.commit('setLaterals', null)
    return
  }
  const properties = poi.properties
  context.commit('setAltitude', properties.altitude)
  context.commit('setName', properties.has_mini ? properties.filename.replace('.jpg', '_@.jpg') : properties.filename)
  context.commit('setDate', properties.date)
  context.commit('setPan', properties.pan)
  context.commit('setPitch', properties.pitch)
  context.commit('setRoll', properties.roll)
  context.commit('setLaterals', properties.resources)
  const latLng = {
    lat: poi.geometry.coordinates[1],
    lng: poi.geometry.coordinates[0]
  }
  context.commit('setLatLng', latLng)

  const folder = getPoiFolder(context.state.campaigns, poi, this.$config.panoramas.media)
  context.commit('setFolderPanorama', folder)
}

export function resetPanorama (context) {
  context.commit('setNeighbours', null)
  context.commit('setAltitude', null)
  context.commit('setLatLng', null)
  context.commit('setName', '')
  context.commit('setDate', '')
  context.commit('setPan', null)
  context.commit('setPitch', null)
  context.commit('setRoll', null)
  context.commit('setLaterals', null)
}

export function setSrcPannellum (context) {
  if (!context.state.name || context.state.name === '') {
    context.state.srcPannellum = this.$config.panoramas.noImage
  } else {
    let params = '?name=' + context.state.folderPanorama + context.state.name +
      `&center=${context.state.latLng.lat},${context.state.latLng.lng},${context.state.altitude}` +
      `&head=${90 - context.state.pan - context.state.head}` +
      `&azimut=${context.state.pan}` +
      `&pitch=${context.state.pitch}` +
      `&roll=${context.state.roll}` +
      `&date=${context.state.date}` +
      `&access_token=${context.rootState.auth.accessToken}`
    if (context.state.screenshot) {
      params += `&screenshot=${context.state.screenshot}`
    }
    context.state.srcPannellum = this.$config.panoramas.pannellum + params
  }
}

export function setSrcPotree (context) {
  if (!context.state.currentPointclouds || context.state.currentPointclouds.length === 0) {
    context.state.srcPotree = this.$config.panoramas.noPointCloud
  } else {
    if (!context.state.srcPotree !== this.$config.panoramas.potree + `?access_token=${context.rootState.auth.accessToken}`) {
      context.state.srcPotree = this.$config.panoramas.potree + `?access_token=${context.rootState.auth.accessToken}`
    }
    const iframe = window.frames['mapiaPointCloud']
    if (iframe && iframe.mapiaPotree) {
      const neighbours = context.state.neighbours.map(neighbour => {
        const coords = [...neighbour.geometry.coordinates]
        return [...coords.reverse(), neighbour.properties.altitude]
      })
      const panoConfig = {
        name: context.state.folderPanorama + context.state.name,
        center: [context.state.latLng.lat, context.state.latLng.lng, context.state.altitude],
        head: 90 - context.state.pan - context.state.head,
        azimut: context.state.pan,
        pitch: context.state.pitch,
        roll: context.state.roll,
        date: context.state.date,
        neighbours
      }
      iframe.mapiaPotree.setOption('panoConfig', panoConfig)
    }
  }
}

function goToNearest (context, currentPoi, neighbours) {
  const prevNeighbour = neighbours.reduce((prev, curr) => {
    return absDiff(prev.id, currentPoi.id) < absDiff(curr.id, currentPoi.id) ? prev : curr
  })
  if (currentPoi.id - prevNeighbour.id > 10) {
    return
  }
  const latLng = {
    lat: prevNeighbour.geometry.coordinates[1],
    lng: prevNeighbour.geometry.coordinates[0]
  }
  context.dispatch('getPanoByPoint', latLng)
}

export function getPreviousPano (context) {
  const currentPoi = context.state.result.poi.features[0]
  const prevNeighbours = context.state.neighbours.filter(poi => {
    return poi.id < currentPoi.id
  })
  goToNearest(context, currentPoi, prevNeighbours)
}

export function getNextPano (context) {
  const currentPoi = context.state.result.poi.features[0]
  const nextNeighbours = context.state.neighbours.filter(poi => {
    return poi.id > currentPoi.id
  })
  goToNearest(context, currentPoi, nextNeighbours)
}

function getLateralFolder (campaigns, poi, selectedLateral, media) {
  const poiCampaign = campaigns.filter(campaign => campaign.id === poi.properties.campaign)[0]
  if (selectedLateral.folder?.startsWith('http')) {
    return selectedLateral.folder
  }
  const lateralFolder = [poiCampaign.folder_pano, selectedLateral.folder].join('/')
  return formatFolder(lateralFolder, media)
}

export function setSrcLateral (context) {
  const selectedLateral = context.state.selectedLateral
  if (selectedLateral) {
    const poi = context.state.result.poi.features[0]
    const lateralFolder = getLateralFolder(context.state.campaigns, poi, selectedLateral, this.$config.panoramas.media)
    context.state.srcLateral = lateralFolder + selectedLateral.filename + `?access_token=${context.rootState.auth.accessToken}`
  }
}

function absDiff (a, b) {
  return Math.abs(a - b)
}

function normalizeAngle (angle) {
  if (angle < 0) {
    angle += 360
  } else if (angle > 360) {
    angle -= 360
  }
  return angle
}

export function selectLateral (context) {
  let head = normalizeAngle(90 - context.state.head)
  const laterals = context.state.laterals
  if (laterals) {
    const angleDiff = (a1, a2) => {
      return absDiff(normalizeAngle(a1), normalizeAngle(a2))
    }
    const selectedLateral = laterals.reduce(function (prev, curr) {
      return angleDiff(prev.pan, head) < angleDiff(curr.pan, head) ? prev : curr
    })
    context.commit('setSelectedLateral', selectedLateral)
    context.dispatch('setSrcLateral')
  }
}
